var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscover = function SvgDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "discover_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 26",
    style: {
      enableBackground: "new 0 0 40 26"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".discover_svg__st2{fill-rule:evenodd;clip-rule:evenodd;fill:#231f20}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M0 0h40v26H0z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "discover_svg__SVGID_1_",
    x1: 19.847,
    x2: 21.349,
    y1: 13.607,
    y2: 10.393,
    gradientTransform: "matrix(1 0 0 -1 0 25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#e45e26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f8a020"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.598,
    cy: 13,
    rx: 1.768,
    ry: 1.774,
    style: {
      fill: "url(#discover_svg__SVGID_1_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 11.401c0-.052 0-.078.071-.072h.955c.458.001.9.175 1.235.488.236.218.394.508.448.826a1.644 1.644 0 0 1-.552 1.657 1.576 1.576 0 0 1-.943.39c-.39.032-.78 0-1.17 0-.052 0-.046 0-.046-.052l.002-3.237zm.65 2.639c0 .045 0 .065.059.059s.26 0 .39 0a.99.99 0 0 0 .65-.266c.286-.267.407-.666.318-1.047a.993.993 0 0 0-.715-.812 2.084 2.084 0 0 0-.604-.058c-.059 0-.078 0-.078.071-.02.363-.02 1.708-.02 2.053zM29.354 13.266 30.4 14.67h-.728a.13.13 0 0 1-.123-.065c-.273-.409-.546-.819-.826-1.222a.065.065 0 0 0-.085 0c-.032 0 0 .039 0 .059v1.203c0 .065 0 .078-.078.078h-.52c-.045 0-.059 0-.059-.059v-3.25c0-.032 0-.052.045-.052h1.118c.255.009.5.103.695.266a.899.899 0 0 1 .286.787.865.865 0 0 1-.702.858l-.069-.007zm-.742-.916v.442c0 .052 0 .065.059.065h.293a.475.475 0 0 0 .468-.481.448.448 0 0 0-.319-.474 1.644 1.644 0 0 0-.442-.045c-.045 0-.059 0-.059.065v.428zM25.681 11.395c0-.052 0-.065.065-.065h1.722c.045 0 .065 0 .065.059v.461c0 .045 0 .052-.059.052h-1.066c-.065 0-.078 0-.072.071v.605c0 .052 0 .065.059.059h1.027c.059 0 .065 0 .065.065v.449c0 .045 0 .052-.059.052h-1.021c-.065 0-.078 0-.072.078v.754c0 .052 0 .071.059.065h1.073c.052 0 .065 0 .065.065v.461c0 .033 0 .045-.052.045h-1.749c-.052 0-.052 0-.052-.058v-3.218zM13.962 13.702a.76.76 0 0 0 .377.377.652.652 0 0 0 .559 0 .422.422 0 0 0 .273-.403.397.397 0 0 0-.253-.39c-.182-.091-.384-.149-.572-.228a1.179 1.179 0 0 1-.488-.338.645.645 0 0 1-.136-.338.93.93 0 0 1 .689-1.072 1.373 1.373 0 0 1 1.3.286s.039.039 0 .072c-.039.033-.195.247-.286.37-.091.123-.045.032-.071 0a.65.65 0 0 0-.377-.221.539.539 0 0 0-.52.162.286.286 0 0 0 .058.435c.143.088.295.158.455.208.148.054.291.12.429.195.267.14.439.413.448.715a1.058 1.058 0 0 1-.793 1.15 1.3 1.3 0 0 1-1.495-.559v-.059l.403-.362zM22.184 11.33h.65c.045 0 .059 0 .078.052.195.5.774 1.95.858 2.171.045-.045.65-1.501.884-2.177 0 0 0-.045.059-.045h.65l-1.424 3.374a.066.066 0 0 1-.072.052h-.253a.066.066 0 0 1-.072-.045l-1.365-3.302c0-.002.014-.048.007-.08zM18.628 12.233a1.581 1.581 0 0 0-.384-.286 1.066 1.066 0 0 0-1.437.611c-.18.425-.094.917.221 1.255.216.23.524.351.839.332a.998.998 0 0 0 .65-.273l.084-.078V14.489c0 .039 0 .058-.039.071a1.813 1.813 0 0 1-2.048-.338 1.717 1.717 0 0 1-.494-1.196 1.762 1.762 0 0 1 2.541-1.593s.039 0 .039.052l.028.748zM13.299 14.599c0 .052 0 .072-.071.072h-.527c-.045 0-.059 0-.059-.052v-3.25c0-.052 0-.059.059-.059h.527c.058 0 .071 0 .071.072v3.217z",
    className: "discover_svg__st2"
  })));
};
export default SvgDiscover;